import { useLocation } from 'wouter'
import { Button } from '../../components/Button'
import { Card } from '../../components/Card'
import { ROUTES } from '../../routes'
import { styled } from '../../setup'
import { colors, spacing, typography } from '../../theme'

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${spacing['2xl']};
`

const IconContainer = styled('div')`
  text-align: center;
  margin-bottom: ${spacing['2xl']};
`

const StatusIcon = styled('div')<{ variant: 'success' | 'denied' }>`
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background: ${(props) => (props.variant === 'success' ? colors.successBg : colors.errorBg)};
  border: 2px solid ${(props) =>
    props.variant === 'success' ? colors.successBorder : colors.errorBorder};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
`

const Title = styled('h2')`
  color: ${colors.textPrimary};
  font-size: ${typography.fontSize2xl};
  font-weight: ${typography.fontWeightSemibold};
  margin: 0 0 ${spacing.lg} 0;
  text-align: center;
`

const Description = styled('p')`
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeBase};
  line-height: 1.6;
  margin: 0 0 ${spacing['2xl']} 0;
  text-align: center;
`

const ButtonGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
`

export function CompletePage() {
  const [location, setLocation] = useLocation()

  // Extract action from URL
  const urlParams = new URLSearchParams(location.split('?')[1] || '')
  const action = urlParams.get('action')

  const isApproved = action === 'approved'

  return (
    <Container>
      <Card maxWidth="480px">
        <IconContainer>
          <StatusIcon variant={isApproved ? 'success' : 'denied'}>
            {isApproved ? (
              <span role="img" aria-label="Success">
                &#10003;
              </span>
            ) : (
              <span role="img" aria-label="Denied">
                &#10007;
              </span>
            )}
          </StatusIcon>
        </IconContainer>

        <Title>{isApproved ? 'Link Approved!' : 'Request Denied'}</Title>

        <Description>
          {isApproved
            ? "You are now connected as a guardian. You can manage this child's account from your Guardian Dashboard."
            : 'The guardian link request has been denied. The child will be notified.'}
        </Description>

        <ButtonGroup>
          {isApproved && (
            <Button
              variant="primary"
              onClick={() => setLocation(ROUTES.GUARDIAN_DASHBOARD)}
              fullWidth
            >
              Go to Guardian Dashboard
            </Button>
          )}
          <Button variant="secondary" onClick={() => setLocation(ROUTES.PROFILE)} fullWidth>
            Go to Profile
          </Button>
        </ButtonGroup>
      </Card>
    </Container>
  )
}
